import { api } from '../../api';
import { actions } from 'store/actions';
import { setErrorToStore } from 'services/utils';

export const deleteAddress = id => async dispatch => {
  try {
    await api.deleteAddress(id);
    dispatch(actions.deleteAddress.act(id));
  } catch (e) {
    setErrorToStore(e, dispatch);
  }
};
